import React from 'react';
import { Box, Typography } from '@mui/material';
import { COLORS, getActiveColor } from '../../pages/app/reports/groups-teams-activity/constants';

interface ProgressBarProps {
    percent: number;
    showLabel?: boolean;
    isDefault?: boolean;
    height?: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
    percent,
    showLabel = true,
    isDefault = false,
    height = 6,
}) => {
    const barColor = isDefault ? COLORS.gray : getActiveColor(percent);
    const labelColor = isDefault ? COLORS.grayMedium : barColor;

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Box
                sx={{
                    flex: 1,
                    height: `${height}px`,
                    backgroundColor: COLORS.grayLight,
                    borderRadius: '3px',
                    overflow: 'hidden',
                    minWidth: '60px',
                }}
            >
                <Box
                    sx={{
                        height: '100%',
                        width: `${Math.max(percent, 0.5)}%`,
                        backgroundColor: barColor,
                        borderRadius: '3px',
                    }}
                />
            </Box>
            {showLabel && (
                <Typography
                    sx={{
                        fontSize: '12px',
                        fontWeight: 600,
                        minWidth: '32px',
                        textAlign: 'right',
                        color: labelColor,
                    }}
                >
                    {percent}%
                </Typography>
            )}
        </Box>
    );
};

// Full-width progress bar used at the top of L2/L3
export const FullWidthProgressBar: React.FC<{ percent: number }> = ({ percent }) => {
    return (
        <Box
            sx={{
                height: '6px',
                borderRadius: '3px',
                backgroundColor: 'rgba(239, 68, 68, 0.2)',
                marginBottom: '16px',
                overflow: 'hidden',
            }}
        >
            <Box
                sx={{
                    height: '100%',
                    width: `${percent}%`,
                    borderRadius: '3px',
                    backgroundColor: COLORS.primary,
                }}
            />
        </Box>
    );
};
